import { Component } from "@angular/core";
import { ALLOWED_CHARACTERS } from "src/config/allowed-characters.config";
import { PrefixComponent } from "../../prefix.component";
import { TemplateHTMLComponent } from "../../templates/template-html/template-html.component";

@Component({
  standalone: true,
  selector: "app-prefix-kob",
  imports: [TemplateHTMLComponent],
  templateUrl: "./prefix-kob.component.html",
  styleUrl: "./prefix-kob.component.less",
})
export class PrefixKobComponent extends PrefixComponent<string> {
  public constructor() {
    super();
    this.post = false;
    this.hide = true;
    this.characters = ALLOWED_CHARACTERS["kob"];
  }
}
